import styles from "@/styles/Price.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
export default function MemberFree() {
  return /*#__PURE__*/_jsx("span", {
    className: "".concat(styles.price, " ").concat(styles.svod, " ").concat(styles.trial),
    children: /*#__PURE__*/_jsx("span", {
      className: styles.slate,
      children: /*#__PURE__*/_jsx("span", {
        className: styles.bold,
        children: "\u4F1A\u54E1\u7121\u6599"
      })
    })
  });
}